<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY <br/></span>A<span class="smallcaps">NDREW</span> M<span class="smallcaps">ILLER</span></h1>
<p class="center"><em class="italic">Ingenious Pain</em></p>
<p class="center"><em class="italic">Casanova</em></p>
<p class="center"><em class="italic">Oxygen</em></p>
<p class="center"><em class="italic">The Optimists</em></p>
<p class="center"><em class="italic">One Morning Like a Bird</em></p>
<p class="center"><em class="italic">Pure</em></p>
<p class="center"><em class="italic">The Crossing</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// now-we-shall-be_00000.vue?71478ab0